<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="false" style="margin-top: 10%">
    <common-dialog id="contactemailDialog" :message="dialogmsg"/>
    <div class="modal-dialog modal-lg" style="min-width: 900px">
      <div class="modal-content" style="min-width: 900px">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="false">&times;</button>
          <h4 id="modalLabel" class="modal-title" style="text-align:center; font-size: 20px; color: #3e4d5c">联系我们</h4>
        </div>
        <div class="modal-body">
          <div class="row margin-top-20 margin-left-20 margin-right-20 margin-bottom-20">
            <div class="col-xs-12 col-md-12 newa">
              <div>
                <div class="row">
                  <div class="col-xs-12 col-md-12">
                    <div class="col-xs-6 col-md-6">
                      <div><img src="@/assets/image/frontlogo.png" alt="UI"></div>
                      <div><h5 style="margin-bottom:-2px;">必孚（中国）</h5></div>
                      <br>
                      <div style="margin-bottom:5px;"><div style="width:80px;display:inline-block;">联系我们</div> <a href="mailto:contact@beeftochina.com">contact@beeftochina.com</a></div>
                      <div style="margin-bottom:5px;"><div style="width:80px;display:inline-block;">商务拓展</div> <a href="mailto:bd@beeftochina.com">bd@beeftochina.com</a></div>
                      <div style="margin-bottom:5px;"><div style="width:80px;display:inline-block;">人力资源</div> <a href="mailto:hr@beeftochina.com">hr@beeftochina.com</a></div>
                      <div style="margin-bottom:5px;"><div style="width:80px;display:inline-block;">官方微信</div> <a href="javascript:void(0);">BTC305548723</a></div>
                      <div><div style="width:80px;display:inline-block;">客服电话</div> <a href="javascript:void(0);">028-64235857</a></div>
                      <div><div style="width:80px;display:inline-block;"/> <a href="javascript:void(0);">028-86658532</a></div>
                      <div><div style="width:80px;display:inline-block;"/> <a href="javascript:void(0);">028-86658093</a></div>
                      <div><div style="width:80px;display:inline-block;"/> <a href="javascript:void(0);">028-86658037</a></div>
                      <div style="margin-top:40px;">
                        <div class="col-xs-6 col-md-6">
                          <div style="width:170px;height:210px; border: solid 1px #eee">
                            <img src="@/assets/image/weixincode.jpg" width="170" higth="170">
                            <center><h5 style="margin-left:10px; margin: 0">BTC必孚牛肉网</h5></center>
                            <center><h5 style="margin-left:10px; margin: 0">扫描添加微信公众号</h5></center>
                          </div>
                        </div>
                        <div class="col-xs-6 col-md-6">
                          <div style="width:170px;height:210px; border: solid 1px #eee;">
                            <img src="@/assets/image/weixinqrcodebeefinfo.jpg" width="170" higth="170">
                            <center><h5 style="margin-left:10px; margin: 0">必孚牛肉资讯</h5></center>
                            <center><h5 style="margin-left:10px; margin: 0">扫描加微信公众号</h5></center>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-6 col-md-6">
                      <form role="form" name="contact">
                        <fieldset>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/namefinal.png" width="24" height="24"> 怎么称呼您？<span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Name" type="text" name="YourName" class="form-control inputstyle" @blur="checkUserName">
                              <span style="color:red"><span>{{ nameerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/companyfinal.png" width="24" height="24"> 您的公司名称？<span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.CompanyName" type="text" name="YourCompany" class="form-control inputstyle" @blur="checkCompanyName">
                              <span style="color:red"><span>{{ companyerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/phonefinal.png" width="24" height="24"> 您的联系电话？<span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Phone" type="text" name="YourPhone" class="form-control inputstyle" @blur="checkPhone">
                              <span style="color:red"><span>{{ phoneerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/emailfinal.png" width="24" height="24"> 您的有效邮箱？<span class="require">*</span>
                            </label>
                            <div>
                              <input v-model="emailBody.Email" type="text" name="YourEmail" class="form-control inputstyle" @blur="checkEmail">
                              <span style="color:red"><span>{{ emailerror }}</span></span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="companyname" class="control-label">
                              <img src="@/assets/image/messagefinal.png" width="24" height="24"> 请问有什么可以帮您？ <span class="require">*</span>
                            </label>
                            <div>
                              <textarea v-model="emailBody.Content" type="text" name="YourMessage" class="form-control inputstyle" style="min-height:80px;" @blur="checkReq"/>
                              <span style="color:red"><span>{{ helperror }}</span></span>
                            </div>
                          </div>
                        </fieldset>
                        <div class="row">
                          <div class="col-xs-12 col-md-12">
                            <button class="btn btn-primary" data-dismiss="modal">取消</button>
                            <button :disabled="false" class="btn btn-danger" style="margin-left: 20px" @click.prevent="sendMail">发送</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import CommonDialog from '@/components/CommonDialog'
export default {
  components: { CommonDialog },
  data() {
    return {
      emailBody: {
        Name: '',
        CompanyName: '',
        Phone: '',
        Email: '',
        Content: ''
      },
      nameerror: '',
      companyerror: '',
      phoneerror: '',
      emailerror: '',
      helperror: '',
      dialogmsg: ''
    }
  },
  methods: {
    sendMail() {
      if (this.isCheck()) {
        this.$store.dispatch('SetLoadingStatus', true)
        this.$store.dispatch('SendMail', this.emailBody).then(() => {
          this.dialogmsg = 'contactemailsendok'
          this.$store.dispatch('SetLoadingStatus', false)
          $('#contactemailDialog').modal({ show: true })
          this.emailBody = {}
        }).catch(() => {
          this.$store.dispatch('SetLoadingStatus', false)
        })
      }
    },
    checkUserName() {
      if (!this.emailBody.Name || !this.emailBody.Name.replace(/\s*/g, '')) {
        this.nameerror = '请填写您的姓名'
        return false
      } else {
        this.nameerror = ''
        return true
      }
    },
    checkCompanyName() {
      if (!this.emailBody.CompanyName || !this.emailBody.CompanyName.replace(/\s*/g, '')) {
        this.companyerror = '请填写您的公司名称'
        return false
      } else {
        this.companyerror = ''
        return true
      }
    },
    checkPhone() {
      if (!this.emailBody.Phone || !this.emailBody.Phone.replace(/\s*/g, '')) {
        this.phoneerror = '请填写您的联系电话'
        return false
      } else if (!/\d+/.test(this.emailBody.Phone)) {
        // !/^[1][3,4,5,7,8,9][0-9]{9}$/
        this.phoneerror = '只允许输入数字'
        return false
      } else {
        this.phoneerror = ''
        return true
      }
    },
    checkEmail() {
      if (!this.emailBody.Email || !this.emailBody.Email.replace(/\s*/g, '')) {
        this.emailerror = '请填写您的电子邮箱'
        return false
      } else if (!/(\S)+[@]{1}(\S)+[.]{1}(\w)+/.test(this.emailBody.Email)) {
        this.emailerror = '邮箱格式有误'
        return false
      } else {
        this.emailerror = ''
        return true
      }
    },
    checkReq() {
      if (!this.emailBody.Content || !this.emailBody.Content.replace(/\s*/g, '')) {
        this.helperror = '请填写您的请求'
        return false
      } else {
        this.helperror = ''
        return true
      }
    },
    isCheck() {
      return this.checkUserName() && this.checkCompanyName() && this.checkPhone() && this.checkEmail() && this.checkReq()
    }
  }
}
</script>

<style scoped>
a { text-decoration: none }
a:link    { color: #E02222 }
a:visited { color: #E02222 }
a:hover   { color: #E02222 }
a:active  { color: #E02222 }
.inputstyle { border: solid 1px #e0e0e0!important }
.inputstyle:focus { border: solid 1px #e0e0e0!important }
</style>



// WEBPACK FOOTER //
// src/views/layout_pork/components/Footer/components/ContactUs/index.vue